<template>
  <section class="vendors">
    <div class="container">
      <h1 class="title">Create New Vendor</h1>
      <div class="card shadow-card">
        <form class="card-body" @submit.prevent="saveNewVendor()" validate>
          <h3>Vendor</h3>
          <div class="form-group">
            <label>Vendor Name</label>
            <input
              type="text"
              v-model="vendor.name"
              class="form-control"
              required
            />
          </div>
          <div class="form-group">
            <label>Vendor Email</label>
            <input
              type="email"
              v-model="vendor.email"
              class="form-control"
              required
            />
          </div>
          <div class="form-group">
            <label>Vendor Website</label>
            <input type="text" v-model="vendor.site" class="form-control" />
          </div>
          <div class="form-group">
            <label>Vendor Phone</label>
            <input
              type="text"
              v-model="vendor.phone"
              class="form-control"
              v-cleave="cleave.phone"
            />
          </div>
          <div class="d-flex align-items-center justify-content-center mt-5">
            <button
              :disabled="saving"
              class="btn btn-primary btn-block btn-300"
            >
              <span v-if="!saving">Create Vendor</span>
              <span
                class="spinner-border spinner-border-sm"
                v-if="saving"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "VendorCreate",
  data() {
    return {
      vendor: {
        name: "",
        email: "",
        phone: "",
        site: "",
      },
      cleave: {
        phone: { blocks: [3, 3, 8], delimiter: "-", numericOnly: true },
      },
    };
  },
  computed: {
    saving: function () {
      return this.$store.saving;
    },
  },
  methods: {
    saveNewVendor: function () {
      this.$store.commit("SET_SAVING_STATE", true, { root: true });
      this.$store.dispatch("vendors/create", this.vendor);
    },
  },
};
</script>
